<template>
  <div class="user_wrap">
    <BreadCrumb crumb="用户审核"></BreadCrumb>
    <!-- <div class="top_bar">
      <el-col :span="8">
        <el-row >
          <el-input placeholder="请输入搜索内容: 账号/手机号/状态" v-model="keyword" class="input-with-select" size="small">
            <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
          </el-input>
        </el-row>
      </el-col>
    </div> -->

    <div class="top_bar">
        <el-row>
          <el-col :span="2">
            <div class="batch_operation" @click='passUserInfo()'>批量操作</div>
          </el-col>
          <el-col :span="2" :offset='2'>
            <div class="batch_operation" @click='passUser(2)'>通过</div>
          </el-col>
          <el-col :span="2">
            <div class="export_data" @click='passUser(3)'>驳回</div>
          </el-col>
        </el-row>
    </div>
   <UserAuditTable :skus="aSkuList" :selectedObj="selectArr" @fnResetTable="fnGetData(1)"></UserAuditTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddSku from '@/components/widget/AddSku'
import UserAuditTable from '@/components/widget/UserAuditTable'
import cons from '@/components/constant'

export default {
  name: 'UserAudit',
  data () {
    return {
      page:1,
      pages:8,
      pagesize:10,
      keyword: '',
      aSkuList:[],
      selectArr: []
    }
  },
  components:{
    BreadCrumb,
    AddSku,
    UserAuditTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/legalizes', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aSkuList = dat.data.data.legalizes;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetKey:function(dat){
       this.keyword = dat;
       this.fnGetData(1);
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    },
    passUserInfo:function(){
      this.$message({
        type: 'info',
        message: '选定用户后，点击通过或驳回!'
      });
    },
    passUser:function(sta){
      var arr = this.selectArr
      if(arr.length === 0){
        this.$message({
          type: 'error',
          message: '请先选定用户，然后点击通过或驳回!'
        });
        return
      }
      let token = localStorage.token;
      this.axios.put(cons.apis + '/v1_0/legalizes',{
          "legalize_ids": arr,  // 用户id列表
          "status": sta // 1解冻 0冻结

        },{
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType:'json'
      }).then(dat=>{
        this.$message({
          type: 'success',
          message: '修改成功!'
        });
        this.fnGetData(1)
      }).catch(err=>{
        console.log(err)
        if(err.response.status==404){
           this.$message({
              type:'info',
              message:'用户未找到！'
            });
        }
      })
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto 10px;
  }


.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/UserAudit.vue